import { api } from '../../../lib/api';
import type { ListQuery, PagedResult } from '../../administration/users/userTypes';
import type { EmployeeAssetDetail, EmployeeAssetListItem } from './employeeAssetTypes';

/**
 * Every facet is written whenever its KEY IS PRESENT, empty string included — an empty value is
 * the reader saying "none of these", which matches no row.
 */
function employeeAssetQuery(query: ListQuery): string {
  const params = new URLSearchParams();

  if (query.search?.trim()) params.set('search', query.search.trim());
  if (query.page && query.page > 1) params.set('page', String(query.page));
  if (query.pageSize) params.set('pageSize', String(query.pageSize));
  if (query.sort) params.set('sort', query.sort);
  if (query.status !== undefined) params.set('status', query.status);

  const text = params.toString();
  return text ? `?${text}` : '';
}

/** Employee Assets — `employee-assets.read` on both. */
export const employeeAssetsApi = {
  list: (query: ListQuery, signal?: AbortSignal) =>
    api<PagedResult<EmployeeAssetListItem>>(`/api/employee-assets${employeeAssetQuery(query)}`, { signal }),

  /** 403 for a record above the reader's personnel access level; 404 for an id naming nobody. */
  get: (personnelId: string, signal?: AbortSignal) =>
    api<EmployeeAssetDetail>(`/api/employee-assets/${personnelId}`, { signal }),
};
